import { OOSReplacementsModalHeader } from './oos-replacements-modal-header';

export { OOSReplacementsModalHeader };
